// extracted by mini-css-extract-plugin
export var modal = "_tf-0";
export var table = "_tf-1";